<template>
  <fieldset :class="[
    vflowGetFeedbackClasses('model'),
    {'mandatory': mandatory}
    ]" class="radio-group">
    <div class="after-label-wrapper">
      <label :class="[{'afterLabel': getSlotText('afterLabel')}]" v-if="label">{{ label }}
      </label>
      <span class="afterLabelElement"><slot name="afterLabel"></slot></span>
    </div>
    <b-form-radio-group
        @click="vflowInputFocused('model'); resetErrorMessages()"
        @input="$v.model.$touch"
        @change="$emit('change')"
        :required="mandatory"
        v-model="model_"
        :name="name"
        :id="name"
    >
      <b-form-radio :id="firstRadioId ? firstRadioId: 'first_option'" :value="firstRadioValue" :class="{disabled: isFirstDisabled}" :disabled="isFirstDisabled"><slot name="lblFirstOption">A</slot></b-form-radio>
      <b-form-radio :id="secondRadioId ? secondRadioId : 'second_option'" :value="secondRadioValue" :class="{disabled: isSecondDisabled}" :disabled="isSecondDisabled"><slot name="lblSecondOption">B</slot></b-form-radio>
    </b-form-radio-group>
    <b-form-invalid-feedback v-if="(!$v.required)">
      <slot name="txtInvalidRequiredBirthDateLiveFeedback">Dies ist ein Pflichtfeld.</slot>
    </b-form-invalid-feedback>
  </fieldset>
</template>

<script>
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import syncProperty from '@/mixins/syncProperty'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'LabeledRadioInput',
  props: {
    name: {
      type: String,
      required: true
    },
    mandatory: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: null
    },
    firstRadioValue: {
      type: String,
      required
    },
    secondRadioValue: {
      type: String,
      required
    },
    firstRadioId: {
      type: String
    },
    secondRadioId: {
      type: String
    },
    isFirstDisabled: {
      type: Boolean,
      default: false
    },
    isSecondDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.invalid_ = this.$v.model.$invalid
  },
  watch: {
    '$v.model.$invalid': function (v) {
      this.invalid_ = v
    }
  },
  mixins: [
    validationMixin,
    validationFlow,
    syncProperty('model', 'model_'),
    syncProperty('invalid', 'invalid_')
  ],
  methods: {},
  validations () {
    return {
      model: {
        ...(this.mandatory ? { required } : {})
      }
    }
  }
}
</script>
